import { APP_INITIALIZER, NgModule } from '@angular/core';
import { IConfig, provideEnvironmentNgxMask } from 'ngx-mask';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { TranslateLoaderFactory } from '../helpers/translate-loader-factory';
import { ImageService } from './services/image.service';
import { CookieService } from 'ngx-cookie-service';
import { LangService, LanguagesEnum } from '@libs/shared/services/lang.service';

export function appInitializerFactory(translate: TranslateService, cookiesService: CookieService, langService: LangService) {
  return () => {
    const lang = langService.getLang();
    translate.setDefaultLang(LanguagesEnum.ua);
    return translate.use(lang).toPromise();
  };
}

const MAT_MODULES = [MatDialogModule];

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [],
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslateLoaderFactory,
        deps: [HttpClient],
      },
    }),
    ...MAT_MODULES,
  ],
  providers: [
    ImageService,
    provideEnvironmentNgxMask(maskConfig),
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, CookieService, LangService],
      multi: true,
    },
  ],
  exports: [TranslateModule, ...MAT_MODULES],
})
export class SharedModule {}
